/**
 * Един флаг в кода:
 * webRegistrationDisabled = true → няма login/register, входът е /mobile-app с hero банер.
 * Банерът на meals за логнати винаги е видим (без отделен флаг).
 */
export const AGAIA_WEB_ACCESS = {
    webRegistrationDisabled: true
};

export function unauthenticatedEntryRoute(): string {
    return AGAIA_WEB_ACCESS.webRegistrationDisabled ? 'mobile-app' : 'login';
}
